import React from "react";
import { Chip, CircularProgress } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { t } from "ttag";

export const statusColor = (status?: string) => {
  if (status === "pass") {
    return "success";
  }
  if (status === "fail") {
    return "error";
  }
  return "default";
};

const statusLabel = (status: string) => {
  if (status === "pass") {
    return t`PASS`;
  }
  if (status === "fail") {
    return t`FAIL`;
  }
  return status.toUpperCase();
};

export const StatusChip = ({ status }: { status?: string }) => {
  if (status === "pending") {
    return (
      <Chip
        size="small"
        color="default"
        icon={<CircularProgress size={12} color="inherit" />}
        label={t`PENDING`}
        title={t`Still comparing this entity`}
      />
    );
  }
  if (!status || status === "unavailable") {
    return (
      <Chip
        size="small"
        color="default"
        label="—"
        title={t`Can't compare — no data from one side`}
      />
    );
  }
  return (
    <Chip
      size="small"
      color={statusColor(status)}
      label={statusLabel(status)}
    />
  );
};

export const PresenceIcon = ({ present }: { present: boolean }) => (
  present ? (
    <CheckIcon fontSize="small" color="success" titleAccess={t`Present`} />
  ) : (
    <CloseIcon fontSize="small" color="error" titleAccess={t`Missing`} />
  )
);

export const FetchStateIcon = ({ state }: { state: "loading" | "fetched" | "missing" }) => {
  if (state === "loading") {
    return <CircularProgress size={14} title={t`Not fetched yet`} />;
  }
  if (state === "fetched") {
    return <CheckIcon fontSize="small" color="success" titleAccess={t`Fetched`} />;
  }
  return <CloseIcon fontSize="small" color="error" titleAccess={t`Not fetched`} />;
};
